<template>
  <div class="Login">
    <div class="video">
      <video ref="video" muted autoplay loop src="@/common/files/login_bg.mp4"></video>
      <div class="video-shadow"></div>
    </div>
    <div class="block">
      <div class="login-introduce">
        <h1>流量变现的未来</h1>
        <p> 我们的平台为您提供：</p>
        <p> 智能广告投放</p>
        <p> 精准用户画像</p>
        <p> 实时数据分析</p>
        <p> 多渠道变现策略</p>
        <p> 加入我们，让您的流量价值最大化！</p>
      </div>
      <div class="form">
        <div class="form-title">
          <img src="@/common/image/login_logo.png" alt="">
          <p>欢迎使用流量变现平台</p>
        </div>
        <div class="form-data">
          <div>
            <el-input :class="textErr ? 'error' : ''" placeholder="请输入邮箱" clearable v-model.trim="email">
              <i slot="prefix" class="iconfont icon-youxiang"></i>
            </el-input>
            <p class="dangerTitle" v-if="textErr">{{ loginMessage }}</p>
          </div>
          <div>
            <el-input :class="pwdErr ? 'error' : ''" :type="pwdType" clearable placeholder="请输入登录密码"
              v-model.trim="password" @keyup.native.13="login" show-password>
              <i slot="prefix" class="iconfont icon-tianchongxing-"></i>
            </el-input>
            <p class="dangerTitle" v-if="pwdErr">{{ pwdMessage }}</p>
          </div>
          <el-checkbox v-model="checked" style="color: #8091b1">下次自动登录</el-checkbox>
          <el-button @click="login" type="primary">登录</el-button>
        </div>
        <p class="agreement">
          登录即表示同意 <span @click="goAgree">服务协议</span> 和 <span @click="goAgree">隐私条款</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from "@/api/index";
export default {
  name: "Login",
  data() {
    return {
      pwdErr: false,
      textErr: false,
      loginMessage: "用户不存在",
      pwdMessage: "",
      pwdBorder: "red",
      lookPwd: false,
      pwdType: "password",
      email: "",
      password: "",
      checked: false, // 是否记住密码
    };
  },
  mounted() {
    this.getCookie();
    let video = this.$refs.video;
    video.addEventListener('loadeddata', this.changeSpeed())
  },
  destoryed() {
    video.removeEventListener('loadeddata', this.changeSpeed())
  },
  methods: {
    changeSpeed() {
      let video = this.$refs.video;
      video.playbackRate = 0.7
    },
    goAgree() {
      window.open("#/agreement", "_blank");
    },
    changeLookPwd() {
      this.lookPwd = !this.lookPwd;
      this.pwdType = this.lookPwd ? "text" : "password";
    },
    login() {
      let that = this;
      if (this.checked == true) {
        window.document.cookie = `email=${this.email}`;
        window.document.cookie = `password=${this.password}`;
      } else {
        window.document.cookie = `email=`;
        window.document.cookie = `password=`;
      }
      window.document.cookie = `remember=${this.checked}`;

      login({
        username: this.email,
        password: this.password,
        type: 1,
        sysType: 3,
      }).then(function (res) {
        that.textErr = false;
        that.pwdErr = false;
        if (res.code == 200) {
          localStorage.setItem("userInfo", JSON.stringify(res.data));
          localStorage.setItem("accessToken", res.data.accessToken);
          localStorage.setItem("refreshToken", res.data.refreshToken);
          that.$router.push("/myindex");
        } else {
          let codes = res.data.code;
          if (codes == 4000004) {
            that.textErr = true;
            that.loginMessage = res.data.msg;
            return;
          }
          if (codes == 2 || codes == 3 || codes == 4 || codes == 5) {
            that.pwdErr = true;
            that.pwdMessage = res.data.msg;
            that.textErr = false;
            return;
          }
          that.pwdErr = true;
          that.pwdMessage = res.data.msg;
          that.textErr = false;
        }
      });
    },
    getCookie() {
      let arr = document.cookie.split("; ");
      arr.forEach((item) => {
        let arr2 = item.split("=");
        if (arr2[0] == "email") {
          this.email = arr2[1];
        } else if (arr2[0] == "password") {
          this.password = arr2[1];
        } else if (arr2[0] == "remember") {
          if (arr2[1] == "true") {
            this.checked = true;
          } else {
            this.checked = false;
          }
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
.dangerTitle {
  margin-top: 10px;
  color: #ff0050;
  margin-bottom: -10px;
}

.agreement {
  text-align: center;
  margin-top: 20px;
  color: #8091b1;
  letter-spacing: 1px;
  font-size: 14px;

  span {
    color: var(--color-main);
    cursor: pointer;
  }
}

/deep/ .el-input__suffix {
  right: 20px;
}

.f_bg {
  margin-top: 166px;
  margin-left: 120px;
  position: relative;
  padding-top: 130px;
  box-sizing: border-box;
  text-align: left;

  h2 {
    font-size: 55px;
    position: relative;
    z-index: 9999;
    color: #0f2349;
  }

  p {
    font-size: 20px;
    margin-top: 10px;
    position: relative;
    z-index: 9999;
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
  }
}

.emaiLogin {
  text-align: left;
  font-size: 18px;
  font-weight: 600;
  color: #0f2349;
  line-height: 18px;
  margin-top: 20px;
  margin-bottom: 10px;
}

.form {
  background: #fff;
  box-shadow: 0 0 8 0 rgba(4, 20, 57, 0.2);
  border-radius: 10px;
  padding: 30px 32px;
  padding-bottom: 50px;
  margin: 0;
  margin-right: 0 !important;
  box-sizing: border-box;
  text-align: left;
  width: 50%;
  /deep/ .el-input {
    input + .el-input__prefix + .el-input__prefix .el-icon-view {
      color: var(--color-main);
    }
  }
  .el-input {
    width: 100%;
    &+.el-input {
      margin-top: 20px;
    }

    /deep/.el-icon-view {
      font-size: 16px;
    }

    /deep/.el-input__prefix {
      line-height: 40px;
      margin-left: 6px;
    }
  }

  /deep/.el-input__inner {
    border: 1px solid #e5e6ea;
    padding-left: 36px;
  }

  /deep/ .el-input__inner:focus {
    border: 1px solid var(--color-main);
  }

  .el-button--primary {
    width: 100%;
    margin-top: 20px;
    border-radius: 60px;
    height: 42px;
  }

  .form-data {
    margin-top: 20px;
    div {
      &+div {
        margin-top: 20px;
      }
    }
  }

  .form-title {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      width: 90px;
    }
    p {
      font-size: 14px;
      font-weight: normal;
      line-height: 20px;
      margin-top: 16px;
    }
  }
}

.Login {
  overflow: hidden;
  position: relative;
  width: 100vw;
  height: 100vh;
}

.video {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 5;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .video-shadow {
    position: absolute;
    z-index: 2;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
  }
}

.block {
  border-radius: 4px;
  background: #fff;
  z-index: 10;
  position: absolute;
  width: 896px;
  height: 542px;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
  display: flex;
  overflow: hidden;
}

.login-introduce {
  width: 50%;
  height: 100%;
  background-color: var(--color-main);
  color: #FFFFFF;
  text-align: left;
  box-sizing: border-box;
  padding: 32px;

  h1 {
    font-size: 30px;
    font-weight: bold;
  }

  p {
    font-size: 16px;
    font-weight: normal;
    line-height: 24px;
    margin-top: 8px;
    position: relative;

    &::before {
      content: '';
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 4px;
      background-color: #FFFFFF;
      margin-right: 4px;
    }

    &:last-child {
      margin-top: 24px;

      &::before {
        display: none;
      }
    }

    &:nth-child(2) {
      margin: 28px 0 16px;

      &::before {
        display: none;
      }
    }
  }
}

.el-checkbox {
  margin-top: 20px;
}

/deep/ .error .el-input__inner {
  border: 1px solid #ff0b58;
}
</style>



// WEBPACK FOOTER //
// src/page/overview/login.vue